module.exports = __webpack_public_path__ + "section/next-page/img/arrow.svg?hash=7f5f9ceba3a2748128a6c241c87ef0b7"


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/asset-loader!./LeLab.LogAlto.Web/src/modules/section/next-page/img/arrow.svg
 ** module id = 97
 ** module chunks = 0 1
 **/